module.exports = __webpack_public_path__ + "media/lonely-astronaut-in-dark-forest-video.c536900c.mp4";